module.exports = __webpack_public_path__ + "./docs/img/logo_vox.48385e19f39ef814ae46d281b9477d04.svg";